import { STORAGE_KEYS, storage, type StorageKey } from '@/lib/storage/keys';

/** JSON reader over the never-throwing storage; malformed or non-object values read as null. */
export function readJsonObject(key: StorageKey): Record<string, unknown> | null {
  const raw = storage.get(key);
  if (raw === null || raw === '') return null;
  try {
    const parsed: unknown = JSON.parse(raw);
    return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)
      ? (parsed as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}

export function writeJson(key: StorageKey, value: unknown): void {
  storage.set(key, JSON.stringify(value));
}

export { STORAGE_KEYS, storage };
